<style>
    .page-item {
        cursor: pointer;
    }
</style>

<template>
    <div class="main-content">
        <section class="section">
          <div class="section-header">
            <h1>Manajement Pengguna</h1>
            <div class="section-header-breadcumb button">
                <a href="javascript:" @click.prevent="goTo('/user/new-user')" class="btn btn-icon icon-left btn-primary"><i class="far fa-edit"></i> Buat Pengguna Baru</a>
            </div>
          </div>
        <div class="section-body">
           <div class="row">
                <div class="col-12">
                    <div class="card">
                    <div class="card-header">
                        <h4>Daftar Pengguna</h4>
                        <div class="card-header-form">
                            <div class="input-group">
                            <input type="text" v-model="filter" @keyup.enter="setFilter()" class="form-control" placeholder="Search Nama, Username , Role">
                            <div class="input-group-btn">
                                <button @click="setFilter()" class="btn btn-primary"><i class="fas fa-search"></i></button>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body p-0">
                        <div class="table-responsive">
                        <table class="table table-striped table-hover">
                            <tr>
                                <th>#</th>
                                <th></th>
                                <th>Username</th>
                                <th>Nama Pengguna</th>
                                <th>Role</th>
                                <th>Perlihatkan Harga?</th>
                                <th>Aktif?</th>
                            </tr>
                            <tbody>
                                <tr style="cursor:pointer;" v-for="list in userList" v-bind:key="list.main.id_produk" @click="goDetail(list.main.id_user)">
                                    <td>{{ list.no }}</td>
                                    <td></td>
                                    <td>{{ list.main.user_login }}</td>
                                    <td>{{ list.main.user_fullname }}</td>
                                    <td>{{ list.main.deskripsi_level }} </td>
                                    <td v-html="booleanCallback(list.main.is_price)"></td>
                                    <td v-html="booleanCallback(list.main.user_status)"></td>
                                </tr>
                            </tbody>
                            
                        </table>
                        </div>
                    </div>
                    <div class="card-footer text-right">
                        <nav class="d-inline-block">
                        <ul class="pagination mb-0">
                            <li class="page-item" :class="{ disabled : firstDisabled }">
                                <a class="page-link" v-if="firstDisabled == true" tabindex="-1"><i class="fas fa-chevron-left"></i></a>
                                <a class="page-link" v-else @click="tableTo(page-1)" tabindex="-1"><i class="fas fa-chevron-left"></i></a>
                            </li>
                            <li v-for="pages in pagination" v-bind:key="pages" class="page-item" :class="{ active: pages == page}">
                                <span class="page-link" @click="tableTo(pages)">{{ pages }}</span>
                            </li>
                            <li class="page-item" :class="{ disabled : lastDisabled }">
                                <a class="page-link" v-if="lastDisabled == true"><i class="fas fa-chevron-right"></i></a>
                                <a class="page-link" v-else @click="tableTo(page+1)"><i class="fas fa-chevron-right"></i></a>
                            </li>
                        </ul>
                        </nav>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        </section>
    </div>
</template>
<script>
export default {
    data() {
        return {
            userList : [],
            perPage: 10,
            page: 1,
            search: '',
            maxPagination: 5,
            first: 1,
            last: '',
            totalRow: '',
            pagination: [],
            filter : '',
            firstDisabled : true,
            lastDisabled : true,
            siteUrl : window.location.href.substr(0, window.location.href.indexOf('#')),
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init: function() {
            this.$root.is_loading = !this.$root.is_loading;
            this.$http.get("User/getUserList?perPage="+this.perPage+"&page="+this.page+"&search="+this.filter).then(result => {
			    if(result.data.code == '00') {
                    alert('failed get user')
                }
                else {
                    this.userList = result.data.detail.data;
                    this.totalRow = result.data.detail.totalRow;
                    this.last = Math.ceil(this.totalRow / this.perPage)
                    this.pagination = this.getPaging();
                    this.$nextTick(function(){
                        this.navDisabled();
                    })
                    
                }
                this.$root.is_loading = !this.$root.is_loading;
			}, error => {
                this.$root.is_loading = !this.$root.is_loading;
				console.log('gk ok')
				context.errors = errors;
            });
        },
        goTo: function(paths) {
            this.$router.push({ path : paths })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
            // this.$router.go();
        },
        getPaging: function() {
            var i;
            var paging = []
            if(this.page > this.first+2){
                this.first = this.page-3
            }else if(this.page == this.first && this.first != 1){
                this.first = this.page-3
                if(this.first < 1){
                    this.first = 1
                }
            }
            for(i = this.first;i < 6+this.first && i <= this.last; i++){
                paging.push(i)
            }
            return paging;
        },
        tableTo: function(page){
            this.page = page
            this.init();
        },
        goDetail: function(id_user){
            this.$router.push({ path : '/user/user-detail/'+id_user })
            var $path = window.location.href.split('/');
            this.isActive = this.$route.path;
        },
        setFilter: function(){
            this.page = 1;
            this.init();
        },
        navDisabled : function() {
            console.log(this.page)
            console.log(this.first)
            console.log(this.last)
            if(this.page == this.first){
                this.firstDisabled = true
                if(this.page < this.last) {
                    this.lastDisabled = false
                }
                return
            }
            if(this.page == this.last) {
                this.lastDisabled = true
                if(this.page > this.first) {
                    this.firstDisabled = false
                }
                return
            }
            if(this.page > this.first && this.page < this.last) {
                this.lastDisabled = false
                this.firstDisabled = false
            }

        },
        booleanCallback : function(val) {
            if(val == 1){
                return '<span style="color:green;">Ya</span>'
            }else{
                return '<span style="color:red;">Tidak</span>'
            }
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/user/User.vue